module.exports = __webpack_public_path__ + "img/google-play.57346d8.svg";